module.exports = __webpack_public_path__ + "img/atb.17775c0b.jpg";